export function centsToDisplay(cents: number, currency = 'USD'): string {
  if (!Number.isFinite(cents) || !Number.isInteger(cents)) {
    throw new TypeError(`centsToDisplay expects an integer; received ${cents}`);
  }
  const dollars = cents / 100;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(dollars);
}

export function dollarsToCents(dollars: number): number {
  if (!Number.isFinite(dollars)) {
    throw new TypeError(`dollarsToCents expects a finite number; received ${dollars}`);
  }
  return Math.round(dollars * 100);
}
